/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./multi-game-difficulty-item.vue?vue&type=template&id=e4f4b5dc&"
import script from "./multi-game-difficulty-item.vue?vue&type=script&lang=js&"
export * from "./multi-game-difficulty-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports